module.exports = __webpack_public_path__ + "img/ACTIVE_SESSIONS.186036b0.svg";